export const appCheckIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.08899 8.79787C4.52782 9.42065 6.23382 11.3674 6.23382 11.3674C6.23382 11.3674 10.7286 6.12546 11.9112 4.62927" stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    name: 'check'
};